interface Props {
  header: string;
}
// Account controls and platform navigation now live in the shared Header.
export function MainLayoutMobileHeader({ header }: Props) {
  return (
    <div className="container py-4 lg:hidden">
      <p className="text-sm font-semibold text-muted-foreground">{header}</p>
    </div>
  );
}
